import { Component, Input } from '@angular/core';
import {
    FrameworkColumn,
    ILocation,
    ITableCellValueRenderer,
    SafeAny,
} from '@pf/shared-common';

@Component({
    selector: 'platform-location-cell-renderer',
    template: `
        <pf-address-renderer
            [addressName]="addressName"
            [value]="value.address"></pf-address-renderer>
    `,
    styles: [``],
    standalone: false,
})
export class LocationCellRendererComponent implements ITableCellValueRenderer {
    private _value!: ILocation;
    @Input() nameFn?: (value: SafeAny) => string;
    addressName?: string;

    @Input() set value(location: ILocation) {
        this._value = location;
        if (this.nameFn) {
            this.addressName = this.nameFn(location);
        } else {
            this.addressName = location.locationName;
        }
    }

    get value() {
        return this._value;
    }

    @Input() column!: FrameworkColumn;
    @Input() row!: SafeAny;
}
